import { useCallback, useEffect, useState } from 'react'
import RequestBreadcrumb from '../../common/RequestBreadcrumb'
import { Form } from 'react-bootstrap'
import DisplayNamewithLeftBorder from '../../common/DisplayNamewithLeftBorder'
import { FORM_CONTROLFIELD_TYPES } from '../../../constants/constants'
import CustomInputs from '../../common/Inputs'
import { useError } from '../../../utils/context/ErrorContext'
import apiHelper from '../../../utils/apiHelper'
import { OrganizationService } from '@propertelligent/client-api'
import { UserLoginData } from '../../common/charts/Enums'
import AddButtonWithArrow from '../../firstTimeUserExperience/commonCom/AddButtonWithArrow'
import View from './View'
import BasicDetailsCard from '../BasicDetails/common/BasicDetailsCard'
import AddTraspButton from '../../firstTimeUserExperience/commonCom/AddTraspButton'
import SimpleSpinner from '../../loader'
import { validateDays } from '../../../utils/validateHelper'

const index = () => {
    const { errors, setErrors, errorMessages, setErrorMessages, clearErrors } = useError();
    const [values, setValues] = useState({
        rentDueDay: "",
        gracePeriods: "",
        monthlyPnl: ""
    })
    const [isEdit, setIsEdit] = useState(false)
    const [dataLoading, setDataLoading] = useState(true);
    const organizationId = Number(sessionStorage.getItem(UserLoginData.organization_id));

    const handleChange = (e) => {
        const { name, value } = e.target;
        let value1 = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
        if (value1.length > 2) value1 = value1.slice(0, 9);
        setValues({ ...values, [name]: value1 })
        setErrors((prev) => ({ ...prev, [name]: false }));
    }

    const checkEmptyFields = (): boolean => {
        let hasError = false;
        clearErrors();
        const newErrors = { ...errors };
        const newErrorMessages = { ...errorMessages };

        let RentDueDay = Number(values?.rentDueDay);
        let GracePeriods = Number(values?.gracePeriods)
        let MonthlyPnl = Number(values?.monthlyPnl)

        if (!RentDueDay || isNaN((RentDueDay)) || RentDueDay < 1 || RentDueDay > 31) {
            newErrors.rentDueDay = true;
            newErrorMessages.rentDueDay = values?.rentDueDay === ""
                ? "Rent Due Day is required"
                : "Day must be between 1 and 31";
            hasError = true;
        } else {
            newErrors.rentDueDay = false;
            newErrorMessages.rentDueDay = "";
        }

        if (!GracePeriods || isNaN((GracePeriods)) || GracePeriods < 1 || GracePeriods > 31) {
            newErrors.gracePeriods = true;
            newErrorMessages.gracePeriods = values?.gracePeriods === ""
                ? "Grace Periods is required"
                : "Grace Periods must be between 1 and 31";
            hasError = true;
        } else {
            newErrors.gracePeriods = false;
            newErrorMessages.gracePeriods = "";
        }

        if (!MonthlyPnl || isNaN((MonthlyPnl)) || MonthlyPnl < 1 || MonthlyPnl > 31) {
            newErrors.monthlyPnl = true;
            newErrorMessages.monthlyPnl = values?.monthlyPnl === ""
                ? "Monthly Pnl is required"
                : "Monthly Pnl must be between 1 and 31";
            hasError = true;
        } else {
            newErrors.monthlyPnl = false;
            newErrorMessages.monthlyPnl = "";
        }

        setErrors(newErrors);
        setErrorMessages(newErrorMessages);
        return hasError;
    };

    useEffect(() => {
        getData()
        clearErrors()
    }, [isEdit])

    const getData = useCallback(() => {
        apiHelper(OrganizationService.getApiOrganizationProcessingDays, { showNotification: false }, organizationId)
            .then((res) => {
                setDataLoading(false)
                setValues({
                    ...values,
                    rentDueDay: res?.data?.success?.rentDueDay,
                    gracePeriods: res?.data?.success?.gracePeriod,
                    monthlyPnl: res?.data?.success?.pnlProcessingDay
                })
            }).catch((err) => { })
    }, [isEdit])

    const handleSubmit = (e) => {
        e.preventDefault()
        if (checkEmptyFields()) {
        } else {
            const updateObject = {
                rentDueDay: Number(values?.rentDueDay),
                gracePeriod: Number(values?.gracePeriods),
                pnlProcessingDay: Number(values?.monthlyPnl)
            }
            apiHelper(OrganizationService.putApiOrganizationProcessingDays,
                {
                    successMessage: "Updated Successfully",
                    failureMessage: "Unable to Update",
                    showNotification: true
                }, organizationId, updateObject)
                .then((res) => {
                    if (res?.data?.success) {
                        getData()
                        setIsEdit(false)
                    }
                }).catch((err) => { })
        }
    }

    return (
        <div className='basic_details fees_and_commissions_container'>
            <div className="basic_detail_breadcrumb">
                <RequestBreadcrumb
                    firstName={"Dashboard"}
                    link={"/"}
                    currentStep={"Payment Processing Dates"}
                />
            </div>
            {!isEdit && <div className="organization_card_container">
                <BasicDetailsCard />
            </div>}
            <div className='basic_details_container' style={{ height: !isEdit && "unset", overflow: !isEdit && "unset" }}>
                <div className='d-flex align-items-center justify-content-between'>
                    <h3 className='main_heading fw-bold black'>Payment Processing Dates</h3>
                    {!isEdit && <p className='normal_text blue clickable' onClick={() => setIsEdit(true)}>Edit Details</p>}
                </div>
                {isEdit ?
                    <form className='pt-4 feesCommissionForm' onSubmit={handleSubmit}>
                        <div className='security_deposit_container'>
                            <DisplayNamewithLeftBorder
                                HeaderName="Rent Collection"
                            />
                            <div className='mt-3 mb-3 d-flex align-items-center gap-3'>
                                <CustomInputs
                                    labelText={"Rent Due Day"}
                                    name={"rentDueDay"}
                                    type={FORM_CONTROLFIELD_TYPES.NUMBER}
                                    value={values?.rentDueDay}
                                    onChange={handleChange}
                                    placeholder="Enter Day"
                                    myClassName="normal_text"
                                    isError={errors.rentDueDay}
                                    errorMessages={errorMessages.rentDueDay}
                                    height={"48px"}
                                    currencyHeight={"48px"}
                                    width={"150px"}
                                    onBlur={() => validateDays("rentDueDay", values.rentDueDay, setErrors, setErrorMessages)}
                                    maxLength={2}
                                    required
                                />
                                <p className='normal_text grey_subtext1 mt-2'>of Month</p>
                            </div>
                            <CustomInputs
                                labelText={"Rent Grace Period"}
                                name={"gracePeriods"}
                                type={FORM_CONTROLFIELD_TYPES.NUMBER}
                                value={values?.gracePeriods}
                                currencySymbol="Days"
                                onChange={handleChange}
                                placeholder="Enter Grace Period"
                                myClassName="normal_text"
                                isError={errors.gracePeriods}
                                errorMessages={errorMessages.gracePeriods}
                                height={"48px"}
                                currencyHeight={"48px"}
                                width={"205px"}
                                maxLength={2}
                                onBlur={() => validateDays("gracePeriods", values.gracePeriods, setErrors, setErrorMessages)}
                                required
                            />
                        </div>
                        <div>
                            <DisplayNamewithLeftBorder
                                HeaderName="Statements"
                            />
                            <div className='mt-3 mb-3 d-flex align-items-center gap-3'>
                                <CustomInputs
                                    labelText={"Generate Monthly PNL *"}
                                    name={"monthlyPnl"}
                                    type={FORM_CONTROLFIELD_TYPES.NUMBER}
                                    value={values?.monthlyPnl}
                                    isFormControl={true}
                                    onChange={handleChange}
                                    placeholder="Enter Day"
                                    myClassName="normal_text"
                                    isError={errors.monthlyPnl}
                                    errorMessages={errorMessages.monthlyPnl}
                                    height={"48px"}
                                    currencyHeight={"48px"}
                                    width={"170px"}
                                    onBlur={() => validateDays("monthlyPnl", values.monthlyPnl, setErrors, setErrorMessages)}
                                />
                                <p className='normal_text grey_subtext1 mt-2'>of Month</p>
                            </div>
                        </div>
                        <div className="basic_details_footer d-flex align-items-center" style={{ gap: "25px" }}>

                            <AddTraspButton
                                type="button"
                                bname="Cancel"
                                onClick={() => setIsEdit(false)}
                                width="fit-content"
                            />
                            <AddButtonWithArrow
                                type="submit"
                                buttonname="Save"
                                minWidth="100px"
                            />
                        </div>
                    </form>
                    :
                    (
                        dataLoading ? <div className='h-100 w-100 justify-content-center align-items-center' style={{ display: dataLoading ? "block" : "none", marginTop: "80px" }}>
                            <SimpleSpinner />
                        </div> : <View values={values} />
                    )
                }
            </div>
        </div>
    )
}

export default index